const preferences = {
  preferenceSettings: {
    nameAlreadyExist: 'Herhaalde naam!',
    nameIsEmpty: 'Naam is leeg!',
    notificationPreference: 'Selecteer de sites en de bijbehorende instellingen voor meldingsvoorkeuren',
    option1: 'Ik will Enphase aanbevolen meldingen ontvangen voor alle sites',
    option2: 'Ik wil mijn meldingen aanpassen',
    pageHeader: 'Voorkeuren',
    title: 'Selecteer een optie voor meldingen',
    saveDialogHeader: 'Wijzigingen opslaan?',
    saveConfirmText: 'Wilt u de wijzigingen die u heeft aangebracht, opslaan?',
    cancelButton: 'Wissen',
    saveButton: 'Opslaan',
    defaultDeselectWarning: 'Let op: U kunt sites niet verwijderen uit de standaard voorkeursinstellingen',
    displayPreferences: 'Voorkeuren weergeven',
    ownSites: 'Eigen sites',
    otherSites: 'Andere sites',
    emptySites: 'Geen sites beschikbaar!',
    emptyPreferenceSet: 'Geen voorkeuren!',
    preference: 'Voorkeur',
    actions: 'Acties',
    settingsInfo: 'Deze instellingen zijn alleen van toepassing voor Ensemble sites',
    selectType: 'SVoorkeurssets',
    selectSite: 'Site selectie',
    selectSettings: 'Instellingen voor meldingsvoorkeuren',
    addText: 'Toevoegen',
    deleteAlertHeader: 'Verwijdering bevestigen',
    deleteAlertDescription: 'Weet u zeker dat u deze voorkeur permanent wilt verwijderen?',
    deleteAlertCancel: 'Annuleren',
    deleteAlertConfirm: 'Oké',
    siteEditWarning:
      'Standaard zijn alle eigen sites en andere sites ingesteld op respectievelijk "Standaard voorkeur - eigen" en "Standaard voorkeur - overige" als hun meldingsvoorkeur.',
    defaultOwnInfo: 'Alle eigen sites zijn ingesteld op "Standaard voorkeur - eigen"',
    defaultOtherInfo: 'Alle overige sites zijn ingesteld op "Standaard voorkeur - overige"',
    defaultInfo: 'Alle sites zijn ingesteld op "Standaardvoorkeur"',
    createNew: 'Nieuwe voorkeur toevoegen',
    siteEditWarningMinimal: 'Standaard zijn sites ingesteld op "Standaardvoorkeur" als hun meldingsvoorkeur',
    selectAll: 'Selecteer alles',
    generalNotification: 'Algemene meldingen',
    switchToNewPreferencePage: 'NAAR NIEUWE VOORKEURSPAGINA OVERSCHAKELEN'
  },
  preferences: {
    pageHeader: 'Voorkeuren',
    title: 'Voorkeursinstellingen',
    notificationPreference: 'Notificatievoorkeuren',
    activationNotification: 'Stuur me activatiemeldingen.',
    monthlySummary: 'Stuur me maandelijks een samenvatting van de systeemprestaties.',
    newsletters: "Stuur mij nieuwsbrieven, promoties en enquêtes over Enphase's producten of diensten.",
    newLeadsNotification: 'Informeer mij over nieuwe leads en hun statuswijzigingen',
    alertEmail: 'WAARSCHUWINGSMAILVOORKEUREN',
    deviceEventsEmail: 'E-mail mij over gebeurtenissen op apparaatniveau (selecteer hieronder het impactniveau):',
    exceptionsAlertEmail: 'U kunt per systeem uitzonderingen opgeven voor uw waarschuwingsmailvoorkeur.',
    alertPreferences: 'Bekijk de waarschuwingsvoorkeuren per systeem',
    saveNotificationPreferences: 'MELDINGSVOORKEUREN OPSLAAN',
    displayPreferences: 'Weergavevoorkeuren',
    displayUnits: 'Weergave-eenheden',
    metric: 'Metrisch',
    imperial: 'Imperiaal',
    saveDisplayPreferences: 'SCHERMVOORKEUREN OPSLAAN',
    systemAlert: 'Systeemwaarschuwingsvoorkeur: ',
    saveChanges: 'Veranderingen Opslaan',
    label: 'E-mail mij over gebeurtenissen op apparaatniveau (selecteer hieronder het impactniveau):',
    alertEmailPreference: 'Voorkeur voor waarschuwingsmails',
    systems: 'Systemen'
  }
};

export default preferences;
